import { useUser } from '@/data/User';
import { guestUserId } from '@/data/recom';
import { ensureRecomGuestSessionId, readRecomGuestSessionId } from '@/data/recom/guestSession';
import type { RecomIdentity } from '@/data/recom';
import { useMemo } from 'react';

export type RecomIdentityState = {
	identity: RecomIdentity;
	recomUserId: string | null;
	isLoggedIn: boolean;
	isLoadingIdentity: boolean;
};

export const useRecomIdentity = (): RecomIdentityState => {
	const { user, loading } = useUser();

	return useMemo(() => {
		const isLoggedIn = Boolean(user?.isLoggedIn);
		const userId = isLoggedIn ? user?.userId || null : null;
		const sessionId = loading
			? null
			: isLoggedIn
			? readRecomGuestSessionId()
			: ensureRecomGuestSessionId();

		return {
			identity: { userId, sessionId },
			recomUserId: userId ?? (sessionId ? guestUserId(sessionId) : null),
			isLoggedIn,
			isLoadingIdentity: loading,
		};
	}, [user, loading]);
};
